import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from './DetailSubsection';
import React from 'react';
import { SonarText } from '@ui/text';
import { useSonarObjectReference } from '@hooks';
export const ApiName = ({ sonarObjectId }) => {
    const { internalName } = useSonarObjectReference(sonarObjectId !== null && sonarObjectId !== void 0 ? sonarObjectId : 0);
    return (React.createElement(DetailSubsection, { className: 'inline-metadata', title: COPY_SPECIFIC.API_NAME, titleExtra: React.createElement(SonarText, null,
            " ",
            internalName,
            " ") }));
};
